import {createFileRoute, redirect} from '@tanstack/react-router';
import {accessGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';
import ImagesProtocolRequest from '@/practitioner/views/imageProtocol/ImagesProtocolRequest';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

export const Route = createFileRoute('/(practitioner)/image-protocol/image-protocol-request')({
  component: ImagesProtocolRequest,
  beforeLoad: function (args: {context: AppRouterContext; location: {pathname: string}}) {
    grantUser(accessGranted)(args);
    const company = args.context.company;
    if (!company?.isTakePhotoEnabledForPractitioner || !company.isForClinicalTrials) {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
